import { linearGradient } from "framer-motion/client";

export default function AtomicLogo({
  showLabels = true,
  text = "ATMIC",
  orbitStrokeWidth = 3,
  colors = {
    primary: "#3b82f6",
    secondary: "#f43f5e",
    tertiary: "#10b981",
    text1: "#e6edf3",
    text2: "#bccce2",
    text3: "#cfae18",
  },
  className = "",
  size,
  style = {},
}) {
  const isControlled = size !== undefined;
  const { primary, secondary, tertiary,text1,text2,text3 } = colors;

  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={
        isControlled
          ? { width: size, height: size, ...style }
          : { width: "100%", height: "100%", ...style }
      }
    >
      <svg
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="overflow-visible w-full h-full"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          {/* Dynamic Gradients */}
          <linearGradient id="brandGradient">
            <stop offset="0%" stopColor={text1} />
            <stop offset="50%" stopColor={text2} />
            <stop offset="100%" stopColor={text3} />
          </linearGradient>

          <linearGradient id="grad1">
            <stop offset="0%" stopColor={primary} />
            <stop offset="100%" stopColor={secondary} />
          </linearGradient>

          <linearGradient id="grad2">
            <stop offset="0%" stopColor={secondary} />
            <stop offset="100%" stopColor={tertiary} />
          </linearGradient>

          <linearGradient id="grad3">
            <stop offset="0%" stopColor={tertiary} />
            <stop offset="100%" stopColor={primary} />
          </linearGradient>

          <filter id="textShadow">
            <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor={secondary} floodOpacity="0.5" />
            <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor={primary} floodOpacity="0.5" />
          </filter>

          {/* Masks */}
          <mask id="orbitCut1">
            <rect width="100%" height="100%" fill="white" />
            <rect x="60" y="0" width="55" height="400" fill="black" />
          </mask>

          <mask id="orbitCut2">
            <rect width="100%" height="100%" fill="white" />
            <rect x="85" y="0" width="55" height="400" fill="black" />
          </mask>
        </defs>

        {/* Outer Circle */}
        <circle
          cx="100"
          cy="100"
          r="90"
          stroke="url(#brandGradient)"
          strokeWidth="4"
          fill="Transparent"
          fillOpacity="0.75"
        />

        {/* Optional Labels */}
        {showLabels && (
          <>
            <text
              x="100"
              y="32"
              textAnchor="middle"
              fill="#64748b"
              fontSize="10"
              fontWeight="600"
              letterSpacing="0.2em"
            >
              Dev
            </text>
            <text
              x="100"
              y="178"
              textAnchor="middle"
              fill="#64748b"
              fontSize="10"
              fontWeight="600"
              letterSpacing="0.2em"
            >
              Sec
            </text>
          </>
        )}

        {/* Orbits */}
        <g strokeWidth={orbitStrokeWidth} fill="none">
          <ellipse
            cx="100"
            cy="100"
            rx="80"
            ry="26"
            stroke="url(#grad1)"
            transform="rotate(60 100 100)"
            mask="url(#orbitCut1)"
          />
          <ellipse
            cx="100"
            cy="100"
            rx="80"
            ry="26"
            stroke="url(#grad2)"
            transform="rotate(120 100 100)"
            mask="url(#orbitCut2)"
          />
          <ellipse cx="100" cy="100" rx="85" ry="26" stroke="url(#grad3)" />
        </g>

        {/* Electrons */}
        <circle cx="100" cy="133" r="5" fill={secondary} />
        <circle cx="100" cy="65" r="5" fill={primary} />

        {/* Nucleus */}
        <circle cx="100" cy="100" r="18" fill="url(#brandGradient)" />

        {/* Shield */}
        <path
          d="M100 86 L112 90 V100 C112 106 108 109 100 111 C92 109 88 106 88 100 V90 L100 86Z"
          fill="blue"
          fillOpacity="0.75"
        />

        {/* Dynamic Text */}
        <text
          x="100"
          y="108"
          textAnchor="middle"
          fill="url(#brandGradient)"
          filter="url(#textShadow)"
          fontSize="26"
          fontWeight="bold"
          
        >
          {text.split("").map((char, i) => (
            <tspan key={i} dx={i === 2? 50 : 10}>
              {char}
            </tspan>
          ))}
        </text>
      </svg>
    </div>
  );
}
